<template>
  <div id="parent-inline-dd">
    <h5 :style="this.style">{{ this.inputTitle }}</h5>
    <button
      class="search-dropdown btn btn-secondary btn-md col dropdown-toggle"
      type="button"
      id="ddMenuBtn"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      {{ this.isSelected ? parseAttrValue(this.selection) : this.allText }}
      <span class="caret"></span>
    </button>
    <div class="dropdown-menu" aria-labelledby="ddMenuBtn" :allText="this.allText">
      <a class="dropdown-item" @click="setDDSelection(allText, $event)">{{ this.allText }}</a>
      <a
        class="dropdown-item"
        v-for="collection in this.parseObject"
        :key="collection.id"
        :value="collection"
        v-on:click="setDDSelection(collection, $event)"
      >{{ parseAttrValue(collection) }}</a>
    </div>
  </div>
</template>

<script>
export default {
  // Note: data-cards becomes camel case in props
  props: [
    "dataStyle",
    "dataInputTitle",
    "dataColSize",
    "dataCollection",
    "dataValueAttr",
    "dataSelection",
    "dataIsSelected"
  ],
  data() {
    return {
      style: this.dataStyle,
      inputTitle: this.dataInputTitle,
      collection: this.dataCollection,
      valueAttr: this.dataValueAttr,
      selection: this.dataSelection,
      isSelected: this.dataIsSelected,
      allText: "All"
    };
  },
  created() {
    this.allText =
      this.inputTitle === "Filters?"
        ? "All types"
        : this.inputTitle === "Status"
        ? "All status"
        : "All";
  },
  methods: {
    setDDSelection: function(collection, e) {
      e.preventDefault();

      this.selection = collection;
      this.isSelected = this.selection !== null;

      // For transaction history & my vouchers page
      if (
        this.inputTitle === "Show" ||
        this.inputTitle === "Filters?" ||
        this.inputTitle === "Filters"
      ) {
        $("input#filter_type").val(this.selection);
      } else if (this.inputTitle === "Card") {
        $("input#bcard_number").val(this.selection);
      } else if (this.inputTitle === "Status") {
        $("input#filter_status").val(this.selection);
      }
    },
    shortenCardDesc: function(data) {
      return "Card" + " ..." + data.card_no.substr(data.card_no.length - 4);
    },
    parseAttrValue: function(data) {
      return this.inputTitle === "date range" && data !== "All"
        ? data.label
        : data === "All" || !this.dataValueAttr
        ? data
        : this.shortenCardDesc(data);
    },
    onClose: function() {
      this.selection = null;
      this.isSelected = false;
    }
  },
  computed: {
    parseObject: function() {
      return JSON.parse(this.dataCollection);
    }
  },
  mounted() {
    $("div.inline-label-input.card-selector").addClass(this.dataColSize);
  }
};
</script>
